import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View, Text, Button } from '@olxbr/design-system'

import svgPath from '../../../assets/icons/tick'
import Svg from '../../atoms/Svg'

const Content = styled(View)`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const TextWithCheck = ({ render }) => (
  <Content>
    <Svg viewBox="0 0 24 24" width={24} height={24} svgPath={svgPath} color="#4A4A4A" />
    {render()}
  </Content>
)

TextWithCheck.propTypes = {
  render: PropTypes.func.isRequired,
}

export default TextWithCheck
